import { endpoints } from "@/api/endpoints/endpoints";
import {
  deleteMessageTemplate,
  getMessageTemplate,
} from "@/api/message-template-api";
import { useCollectionData, useMutation } from "@/hooks/use-api";

export function useGetMessageTemplate(id: string) {
  const cacheKey = endpoints.messageTemplate.get(id);

  return useCollectionData(cacheKey, () => getMessageTemplate(id), {
    refreshInterval: 0,
    revalidateOnFocus: false,
  });
}

export function useDeleteMessageTemplate() {
  return useMutation(deleteMessageTemplate, {
    onSuccess: (response) => {
      console.log("MessageTemplate deleted successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error deleting MessageTemplate:", error);
    },
  });
}
